// library imports
import { Flex, Select } from "antd";
import { useEffect, useState } from "react";

export default function SiteSelection({
  siteSelected,
  setSiteSelected,
  siteList,
  loading,
  menuSelectedKey,
  disabled,
}) {
  const [filteredSiteList, setFilteredSiteList] = useState([]);

  // if route contains 'Features', need to filter siteList based on the site subscription to different features
  // TODO: temp solution, site selected has issue when change site (site selected at the very first load will be the one which does not have AI-BESS subscription but
  // then later it will be very fast being set to the site which has AI-BESS subscription - see useSiteSelection.js, SiteSelection.js)
  useEffect(() => {
    if (window.location.pathname.split("/").includes("Features")) {
      let url_length = window.location.pathname.split("/").length;
      if (window.location.pathname.split("/")[url_length - 1] == "PPABilling") {
        setFilteredSiteList(siteList.filter((site) => site.PpaBilling));
        setSiteSelected(siteList.filter((site) => site.PpaBilling)[0]?.value);
      } else if (
        window.location.pathname.split("/")[url_length - 1] ==
        "CarbonManagement"
      ) {
        setFilteredSiteList(siteList.filter((site) => site.CarbonManagement));
        setSiteSelected(
          siteList.filter((site) => site.CarbonManagement)[0]?.value
        );
      } else if (
        window.location.pathname.split("/")[url_length - 1] == "AIPVDiagnosis"
      ) {
        setFilteredSiteList(siteList.filter((site) => site.AiPvDiagnosis));
        setSiteSelected(
          siteList.filter((site) => site.AiPvDiagnosis)[0]?.value
        );
      } else if (
        window.location.pathname.split("/")[url_length - 1] == "AIEDR"
      ) {
        setFilteredSiteList(siteList.filter((site) => site.AiBess));
        setSiteSelected(siteList.filter((site) => site.AiBess)[0]?.value);
      }
    } else {
      setFilteredSiteList(siteList);
    }
  }, [menuSelectedKey, siteList]);

  return (
    <Flex align="center">
      <p className="mr-2">Site:</p>
      <Select
        disabled={disabled}
        style={{ minWidth: "calc(100vw - 54px)", textAlign: "left" }}
        loading={loading}
        showSearch
        value={siteSelected}
        options={filteredSiteList}
        optionFilterProp="label"
        labelRender={(value) => <>{value.label}</>}
        onChange={(value) => {
          setSiteSelected(value);
        }}
      />
    </Flex>
  );
}
